import React from "react";
import Grid from "@material-ui/core/Grid";
import DialogContent from "@material-ui/core/DialogContent";
import TotalPrizeIntro from "./TotalPrizeIntro";
import Dialog from "@material-ui/core/Dialog";
import {numberSplitor} from "../../../../Utility/Func";


class TotalPrize extends React.Component{
    constructor() {
        super();
    }
    componentDidMount() {
    }


    render() {
        const{name,
            totalPrize,
            score,
            starRequireToUnlock,
            key,
            backgroundColor,
            star,
            prizeIcon,
            image,
            lock,
            locked,
            backgroundImage,
            gameType}=this.props.prize
        return(
            <Grid container alignItems={"center"} justify={"center"}
                  style={{position:'relative'}}
            >
                {locked &&
                <Grid className={'total-prize-lock-requirement'} style={{width: '25%', color:'#ffffff',backgroundColor: '#190f4d'}}
                      justify={"center"} alignItems={"center"} container item>
                    <Grid container justify={"center"} item sm={4} xs={4}>
                        <img className={'total-prize-lock-requirement-icon'} src={key} alt=""/>
                    </Grid>
                    <Grid container justify={"center"} item sm={4} xs={4}>
                        <img className={'total-prize-lock-requirement-icon'} src={star} alt=""/>
                    </Grid>
                    <Grid container justify={"center"} item sm={4} xs={4}>
                        {starRequireToUnlock}
                    </Grid>
                </Grid>
                }
                {/*<Grid xs={3} sm={3} container direction={"column"} className={'total-prize-requirement fullHeight'} alignItems={"center"} justify={"center"} item>*/}
                    {locked &&
                    <img src={lock} alt="" style={{width: '20%',right:'6%', position: 'absolute', zIndex: '3'}}/>
                    }
                    <img src={image}  className={'total-prize-image'} alt=""/>

                {/*</Grid>*/}
                <Grid justify={'center'} alignItems={"center"}  xs={12} sm={12}  item container style={
                    {
                        backgroundImage: "url(" + backgroundImage + ")",
                        backgroundSize:'100% 100%',
                        backgroundRepeat: 'no-repeat',
                        width:'100%',
                        backgroundColor:backgroundColor,
                        backgroundBlendMode:'soft-light',
                        position:'relative',
                        clipPath: 'polygon(3% 0%, 97% 0px, 100% 5%, 100% 94%, 96% 101%, 3% 100%, 0px 95%, 0px 5%)',
                        height:'100px'
                    }} className={'total-prize'}>
                    {locked &&
                    <Grid style={{width:'100%',height:'100%',position:'absolute',backgroundColor:'rgba(0,0,0,0.5)',zIndex:'3'}}>
                    </Grid>
                    }
                    {/*{locked &&*/}
                    {/*<Grid className={'total-prize-lock-requirement'} style={{width: '25%', backgroundColor: '#190f4d'}}*/}
                    {/*      justify={"center"} alignItems={"center"} container item>*/}
                    {/*    <Grid container justify={"center"} item sm={4} xs={4}>*/}
                    {/*        <img className={'total-prize-lock-requirement-icon'} src={key} alt=""/>*/}
                    {/*    </Grid>*/}
                    {/*    <Grid container justify={"center"} item sm={4} xs={4}>*/}
                    {/*        <img className={'total-prize-lock-requirement-icon'} src={star} alt=""/>*/}
                    {/*    </Grid>*/}
                    {/*    <Grid container justify={"center"} item sm={4} xs={4}>*/}
                    {/*        {starRequireToUnlock}*/}
                    {/*    </Grid>*/}
                    {/*</Grid>*/}
                    {/*}*/}
                    <Grid alignItems={"center"} container xs={11} sm={11}
                          style={{backgroundColor:'rgba(0,0,0,0.2)',height:'90%'}} className={'fullHeight'}>
                        <Grid container justify={"flex-end"} className={'fullHeight'}>

                            <Grid xs={9} sm={9} direction={'row-reverse'} container className={'fullHeight'}>
                                <Grid container sm={9} xs={9} justify={"flex-end"} className={'fullHeight'}>

                                    <Grid  style={{height:'50%'}} item xs={9} sm={9} justify={"center"} container alignItems={"flex-end"}>
                                        <p>
                                            مجموع جوایز
                                        </p>
                                    </Grid>

                                    <Grid item xs={10} sm={10} direction={"row-reverse"} justify={"center"} container alignItems={"center"}
                                          style={{height:'50%'}}
                                    >
                                        <Grid   xs={2} sm={2} justify={"center"} container alignItems={"center"} style={{position:'relative'}}>
                                            <img src={prizeIcon} className={'total-prize-icon'} alt=""/>
                                        </Grid>
                                        <Grid alignItems={"center"} justify={"center"} xs={10} sm={10} className={'fullHeight'}>
                                            <p className={'total-prize-price'}>
                                                {numberSplitor(totalPrize)}
                                            </p>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid justify={"center"} alignItems={"center"} container sm={3} xs={3} item style={{position:'relative'}}>
                                    {/*<img src={image}  className={'total-prize-image'} alt=""/>*/}
                                </Grid>
                            </Grid>

                            <Grid xs={3} sm={3} container direction={"column"} className={'total-prize-requirement fullHeight'} alignItems={"center"} justify={"center"} item>
                                {locked &&
                                <Grid style={{width:'100%',height:'100%',position:'absolute',backgroundColor:'rgba(46, 46, 143,0.8)',zIndex:'3'}}>
                                </Grid>
                                }
                                {/*{locked &&*/}
                                {/*<img src={lock} alt="" style={{width: '100%', position: 'absolute', zIndex: '3'}}/>*/}
                                {/*}*/}
                                <Grid item justify={"center"} container alignItems={"center"} className={'total-prize-requirement-top'} style={{margin:'0'}}>
                                    <img src={star} className={'total-prize-requirement-top-icon'} alt=""/>
                                </Grid>
                                <Grid item alignItems={"center"} className={'total-prize-requirement-bottom'} container justify={"center"} style={{margin:'0'}}>
                                    <p>
                                        {score}
                                    </p>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

        )
    }
}
export default TotalPrize